// @flow

import ApiObject from '../ApiObject';

import UserAccount from './UserAccount'

import ArrayUtils from '../../utils/ArrayUtils';
import DateUtils from '../../utils/DateUtils';
import Utils from '../../utils/Utils'

export default class User extends ApiObject {

  static DEFAULT_BIRTHDATE = -2208988800000;

  id: string = '';

  firstName: string = '';

  lastName: string = '';

  phone: string = '';

  email: string = '';

  emailVerified: boolean = true;

  fid: string = '';

  phone: string = ''; // +33630252000. See RFC ? TODO: RFC

  phoneVerified: boolean = true;

  sponsorship: string = '';

  nationality: string = ''; // Two letters: FR. See RFC ? TODO: RFC

  countryOfResidence: string = ''; // Two letters: FR. See RFC ? TODO: RFC

  locale: string = ''; // fr

  country: string = ''; // Two letters: FR. See RFC ? TODO: RFC

  picture: string = '';

  birthdate: number = User.DEFAULT_BIRTHDATE; // timestamp as milliseconds

  registrationDate: number = 0; // timestamp as milliseconds

  credit: number = 0;

  walletId: string = '';

  promotionsUsed: Array<String> = [];

  userAccounts: Array<UserAccount> = [];

  // used to track a user who orders after a registration
  registerId = null;

  postJsonAssignation(data: Object) {
  }

  haveBirthdate() {
    return this.birthdate !== User.DEFAULT_BIRTHDATE;
  }

  getFormattedBirthdate() {
    return DateUtils.fromMsTimestamp(this.birthdate).format('DD/MM/YYYY');
  }

  getEnabledUserAccounts() {
    return this.userAccounts.filter(userAccount => userAccount.enabled)
  }

  findUserAccountById(id) {
    return ArrayUtils.find(this.userAccounts, { id });
  }

  generateRegisterId() {
    this.registerId = Utils.generateUID();
  }
}



// WEBPACK FOOTER //
// ./sdk/scripts/entities/user/User.js